export default __webpack_public_path__ + "static/fire_pump_w.14fde7f0ebd2467882af4fa76749e84f.png";